import { Message } from '@oneflowab/pomes';

type Props = {
  count: number;
};

export const SelectedItemsLabel = ({ count }: Props) => {
  return (
    <Message
      id="1 selected"
      pluralId="{count} selected"
      pluralCondition="count"
      values={{
        count,
      }}
      comment="A message to show the current selected list"
    />
  );
};
